import script from "./changePWD.vue?vue&type=script&setup=true&lang=js"
export * from "./changePWD.vue?vue&type=script&setup=true&lang=js"

import "./changePWD.vue?vue&type=style&index=0&id=e11c922a&lang=scss&scoped=true"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e11c922a"]])

export default __exports__